import { useEffect, useState } from "react";
import { Minus, Plus } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CountryCode } from "libphonenumber-js";
import { Button } from "@/components/ui/button";
import StyledPhoneInput from "@/components/styled/StyledPhoneInput";
import { ControlledUnifiedInput } from "@/components/ui/customs/controlled-unified-input";
import { ExpeditionBoDeliveryInfoFormData } from "@/types/forms/bo/expeditionBo.form";

export const ContactInformations = ({ countryCode }: { countryCode: string }) => {
  const { t } = useTranslation("boExpeditionForm");
  const methods = useFormContext<ExpeditionBoDeliveryInfoFormData>();
  const [additionalContactFlags, setAdditionalContactFlags] = useState<number>(0);

  useEffect(() => {
    if ((additionalContactFlags & 1) === 0) {
      methods.setValue("deliveryInfo.additionalPhone", "");
    }
    if ((additionalContactFlags & 2) === 0) {
      methods.setValue("deliveryInfo.additionalEmail", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalContactFlags]);

  return (
    <>
      <div className="flex flex-col gap-2 @xl:flex-row">
        <div className="flex flex-1 flex-col gap-2 @xl:flex-row">
          <StyledPhoneInput
            control={methods.control}
            name="deliveryInfo.phone"
            title={t("contactInformations.phoneLabel")}
            required
            defaultCountry={(countryCode as CountryCode) || "FR"}
          />
          <Button
            className="h-full"
            variant="outline"
            type="button"
            onClick={() => setAdditionalContactFlags(additionalContactFlags ^ 1)}
          >
            {additionalContactFlags & 1 ? (
              <Minus className="h-4 w-4" />
            ) : (
              <Plus className="h-4 w-4" />
            )}
          </Button>
        </div>
        <div className="flex flex-1 flex-col gap-2 @xl:flex-row">
          <ControlledUnifiedInput
            control={methods.control}
            name="deliveryInfo.email"
            label={t("contactInformations.emailLabel")}
            required
            className="w-full"
            wrapperClassName="w-full"
          />
          <Button
            variant="outline"
            className="h-full"
            type="button"
            onClick={() => setAdditionalContactFlags(additionalContactFlags ^ 2)}
          >
            {additionalContactFlags & 2 ? (
              <Minus className="h-4 w-4" />
            ) : (
              <Plus className="h-4 w-4" />
            )}
          </Button>
        </div>
      </div>
      <div className="flex flex-col gap-2 @xl:flex-row">
        {additionalContactFlags & 1 ? (
          <StyledPhoneInput
            control={methods.control}
            name="deliveryInfo.additionalPhone"
            title={t("contactInformations.additionalPhoneLabel")}
            placeholder={t("contactInformations.additionalPhonePlaceholder")}
            defaultCountry={(countryCode as CountryCode) || "FR"}
          />
        ) : (
          <div className="w-full" />
        )}
        {additionalContactFlags & 2 ? (
          <ControlledUnifiedInput
            control={methods.control}
            name="deliveryInfo.additionalEmail"
            label={t("contactInformations.additionalEmailLabel")}
            className="w-full"
            wrapperClassName="w-full"
          />
        ) : (
          <div className="w-full" />
        )}
      </div>
    </>
  );
};
